/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Ad_Render_TtsInputs */



/**
* | output |
* | --- |
* | "Render Audio Description (DV) text to audio." |
*
* @param {Shortcut_Keys_Desc_Ad_Render_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_ad_render_tts = /** @type {((inputs?: Shortcut_Keys_Desc_Ad_Render_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Ad_Render_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rendre le texte de description audio (DV) en audio.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibungstext (DV) in Audio umwandeln.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trasforma il testo della descrizione audio (DV) in audio.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста описания звука (DV) в аудио.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir texto de descripción de audio (DV) a audio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将音频描述 (DV) 文本渲染为音频。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明 (DV) テキストをオーディオにレンダリングします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण (डीवी) टेक्स्ट को ऑडियो में रूपांतरित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter texto de audiodescrição (DV) em áudio.")
	return /** @type {LocalizedString} */ ("Render Audio Description (DV) text to audio.")
});